// extracted by mini-css-extract-plugin
export default {"content":"payment-method_content__6Ixwu","pay":"payment-method_pay__8qz6q"};